import React from 'react';
import { Spin } from 'antd';
import { CustomSelectContainer } from './styles';

interface LoaderOverlayProps {
	hasIcon: boolean;
	className?: string;
}

export function LoaderOverlay({ hasIcon, className }: Readonly<LoaderOverlayProps>): JSX.Element {
	return (
		<CustomSelectContainer hasIcon={hasIcon} className={className}>
			<Spin />
		</CustomSelectContainer>
	);
}
